import { TrashIcon } from "@heroicons/react/20/solid";

import Headline from "~/components/Headline";

type Props = {
	onDelete?: (phaseId: string) => void;
	phaseId: string;
	phaseTitle: string;
	projectTitle: string;
};

const SelectedQuotaProjectPhase = ({
	onDelete,
	phaseId,
	phaseTitle,
	projectTitle,
}: Props) => {

	return <div
		className="grid w-full grid-cols-[1fr_auto] divide-x divide-gray-300 rounded-lg border border-gray-300 text-sm">
		<div className="px-4 py-3">
			<Headline type="h5"
					  color="muted">{phaseTitle}</Headline>
			<div className="text-sm text-gray-500">{projectTitle}</div>
		</div>
		{onDelete && <button type="button"
							 className="group flex w-10 flex-col items-center justify-center"
							 onClick={() => onDelete(phaseId)}
		>
			<TrashIcon className="size-5 text-danger-500 group-hover:text-danger-700" />
		</button>}
	</div>;
};

export default SelectedQuotaProjectPhase;